import { render } from "./PlaybookTab.vue?vue&type=template&id=1620d0e2&scoped=true"
import script from "./PlaybookTab.vue?vue&type=script&lang=js"
export * from "./PlaybookTab.vue?vue&type=script&lang=js"

import "./PlaybookTab.vue?vue&type=style&index=0&id=1620d0e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1620d0e2"]])

export default __exports__